import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useCallback } from 'react';
import * as Actions from '../../../actions';
const ActionGroupItem = ({
  item,
  size,
  appearance,
  asDropDownItems,
  onActionItemClick
}) => {
  const {
    name,
    hideContent,
    hideIcon,
    onClick,
    isDisabled,
    ...props
  } = item;
  const handleOnClick = useCallback(() => {
    if (onActionItemClick) {
      onActionItemClick();
    }
    if (onClick) {
      onClick();
    }
  }, [onActionItemClick, onClick]);
  const Action = name in Actions ? Actions[name] : undefined;
  if (!Action) {
    return null;
  }
  const actionProps = {
    ...props
  };
  if (hideContent && !asDropDownItems) {
    actionProps.content = '';
  }
  if (hideIcon) {
    actionProps.icon = undefined;
  }
  return jsx(Action, _extends({
    asDropDownItem: asDropDownItems,
    size: size,
    appearance: appearance,
    onClick: handleOnClick,
    isDisabled: isDisabled
  }, actionProps));
};
export default ActionGroupItem;